import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { Modal, DatePicker, Button } from 'antd';
import moment from 'moment';
import FormatUtil from '../../../../../utils/FormatUtil';
import '../../FundMonitoring.css';

const { RangePicker } = DatePicker;
const unresolvedColumns = [
    { field: 'date', headerName: 'Date', width: 140 },
    { field: 'unresolvedCount', headerName: 'No. of Unresolved Flags', width: 220 },
];
const detailColumns = [
    { field: 'ruleId', headerName: 'RuleID', width: 110 },
    { field: 'date', headerName: 'Date', width: 100 },
    { field: 'fund', headerName: 'Fund', width: 90 },
    { field: 'bbgTicker', headerName: 'BbgTicker', width: 120 },
    { field: 'secName', headerName: 'SecName', width: 180, tooltipField: 'secName' },
    { field: 'country', headerName: 'Country', width: 100 },
    { field: 'assetClass', headerName: 'AssetClass', width: 110 },
    { field: 'position', headerName: 'Position', width: 110, valueFormatter: FormatUtil.numValueFormatter1 },
    { field: 'issuedSharePercent', headerName: '% of Issued Share', width: 140, valueFormatter: FormatUtil.percentValueFormatter3 },
    { field: 'marketValueLocal', headerName: 'Market Value Local', width: 150, valueFormatter: FormatUtil.numValueFormatter1 },
    { field: 'type', headerName: 'ExpType', width: 100 },
    { field: 'expMetric', headerName: 'ExpMetric', width: 120 },
    {
        field: 'reportThreshold', headerName: 'Threshold', width: 110, valueFormatter: params => {
            const expMetric = params.data && params.data.expMetric;
            if (expMetric && expMetric.toLowerCase().includes('pct')) {
                return FormatUtil.percentValueFormatter1(params);
            }
            return FormatUtil.numValueFormatter1(params);
        }
    },
];
const alertDetailColumns = detailColumns.map(column => (
    column.field === 'reportThreshold'
        ? { ...column, field: 'alertThreshold' }
        : column
));
const ppmColumns = [
    'ruleId', 'date', 'fund', 'bbgTicker', 'secName', 'country', 'assetClass',
    'position', 'marketValueUSD', 'fundNavPercent', 'type', 'expMetric', 'reportThreshold'
].map(field => {
    const column = detailColumns.find(item => item.field === field) || { field };
    const headerNames = {
        marketValueUSD: 'Market Value USD',
        fundNavPercent: '%FundNAV USD',
        type: 'ExpType (Ref: RuleID)',
        expMetric: 'ExpMetric (Ref: RuleID)',
        reportThreshold: 'Threshold (Ref: RuleID)',
    };
    return {
        ...column,
        headerName: headerNames[field] || column.headerName,
        ...(field === 'fundNavPercent' ? { valueFormatter: FormatUtil.percentValueFormatter3 } : {}),
    };
});

class StatReportModalDialog extends Component {
    state = { dates: [moment().startOf('month'), moment()] };

    renderSection = (title, rows, columns = detailColumns) => <div style={{ marginTop: 16 }}>
        <h4>{title}</h4>
        <div className="ag-theme-balham statReportGrid" style={{ height: 260, width: '100%' }}>
            <AgGridReact
                columnDefs={columns}
                rowData={rows || []}
                defaultColDef={{ sortable: true, filter: true, resizable: true, minWidth: 80 }}
                pagination
                paginationPageSize={50}
                animateRows
            />
        </div>
    </div>;

    render() {
        const { visible, loading, report, onCancel, onGenerate } = this.props;
        return <Modal title="Monthly Stat (統計報告)" visible={visible} width={1200} onCancel={onCancel} footer={null}>
            <div>
                <RangePicker value={this.state.dates} allowClear={false} onChange={dates => this.setState({ dates })} />
                <Button type="primary" loading={loading} style={{ marginLeft: 10 }} onClick={() => onGenerate(this.state.dates[0], this.state.dates[1])}>Generate</Button>
            </div>
            {report && <div>
                <h4>Unresolved as of [{report.fromDate} - {report.toDate}]</h4>
                <div className="ag-theme-balham statReportSummaryGrid" style={{ height: 120, width: '100%' }}>
                    <AgGridReact
                        columnDefs={unresolvedColumns}
                        rowData={report.unresolved || []}
                        defaultColDef={{ sortable: true, filter: true, resizable: true, minWidth: 80 }}
                    />
                </div>
                {this.renderSection('Disclosure: Alert Group', report.disclosureAlert, alertDetailColumns)}
                {this.renderSection('Disclosure: Report Group', report.disclosureReport)}
                {this.renderSection('PPM: Single Concentration Report Group', report.ppmSingleConcentration, ppmColumns)}
            </div>}
        </Modal>;
    }
}

export default StatReportModalDialog;
